import { Link } from 'react-router-dom';
import { ModuleLanding, ModuleOffers, Faq, SectionHead, Rating } from '../../shared/components/Common';
import { SmartImg } from '../../shared/components/Layout';
import Icon from '../../shared/components/Icons';
import { formatPrice, img } from '../../shared/data/common';
import { activities, categories } from './data';

const faqs = [
  ['How will I receive my tickets?', 'Your mobile voucher is emailed instantly after booking. Show it on your phone at the venue — no printout needed.'],
  ['Can I cancel my activity booking?', 'Most activities offer free cancellation up to 24 hours before the start time. Check the policy on each activity page.'],
  ['Are hotel pickups included?', 'Choose the “Ticket + Shared Transfers” or “Premium / Private Tour” option to include hotel pickup and drop.'],
  ['Do children get a discount?', 'Yes, children aged 3–12 get 25% off on most activities. Kids under 3 usually enter free.'],
];

export default function SightseeingSearch() {
  const cities = [...new Set(activities.map((a) => a.city))];
  return (
    <ModuleLanding tab="sightseeing" title="Tours, attractions & experiences" subtitle="Skip-the-line tickets · Instant confirmation · Free cancellation on most activities" image={img('1451337516015-6b6e9a44a8a3', 1800)}>
      <section className="section container">
        <SectionHead title="Explore by category" />
        <div className="theme-tiles">
          {categories.filter((c) => c !== 'All').map((c) => (
            <Link key={c} to={`/sightseeing/results?category=${c}`} className="theme-tile">
              <span className="perk-icon"><Icon name="sightseeing" size={22} /></span>
              <b>{c}</b><span className="muted small">{activities.filter((a) => a.category === c).length} experiences</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Activity offers" />
        <ModuleOffers module="sightseeing" />
      </section>

      <section className="section container">
        <SectionHead title="Top experiences" link={{ to: '/sightseeing/results', label: 'See all' }} />
        <div className="card-grid">
          {[...activities].sort((a, b) => b.reviews - a.reviews).slice(0, 4).map((a) => (
            <Link key={a.id} to={`/sightseeing/${a.id}`} className="card hover">
              <div className="card-img"><SmartImg src={a.image} alt={a.title} /><span className="badge badge-sky">{a.category}</span></div>
              <div className="card-body">
                <span className="muted small"><Icon name="pin" size={12} /> {a.city} · <Icon name="clock" size={12} /> {a.duration}</span>
                <h3>{a.title}</h3>
                <div className="price-row"><div><span className="muted small">from </span><b className="price">{formatPrice(a.price)}</b></div><Rating value={a.rating} compact /></div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Things to do by city" />
        <div className="city-chips">
          {cities.map((c) => (
            <Link key={c} to={`/sightseeing/results?city=${c}`} className="city-chip">
              <Icon name="pin" size={16} /><span><b>{c}</b><small>{activities.filter((a) => a.city === c).length} activities</small></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
